import { useEffect } from 'react';
import { overlay } from 'overlay-kit';
import { useNavigate } from 'react-router-dom';
import { MAX_STEP } from '@/entities/cmo-record/model/constants';
import { Button } from '@/shared/ui';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog';
import { Step1 } from './step1';
import { Step2 } from './step2';

interface CMORecordsStepClientProps {
  readonly step: number;
}

export function CMORecordsStepClient({ step }: CMORecordsStepClientProps) {
  const navigate = useNavigate();

  useEffect(() => {
    const checkStep = async () => {
      if (step > MAX_STEP || step < 1 || Number.isNaN(step)) {
        const response = await overlay.openAsync(({ isOpen, close }) => (
          <Dialog
            onOpenChange={close}
            open={isOpen}
          >
            <DialogContent>
              <DialogHeader>
                <DialogTitle>잘못된 접근</DialogTitle>
                <DialogDescription>유효하지 않은 단계입니다.</DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button
                  onClick={() => close(true)}
                  variant={'primary'}
                >
                  닫기
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        ));

        if (response) {
          navigate('/cmo-records/1');
        }
      }
    };

    checkStep().then();
  }, [step, navigate]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1 step={step} />;
      case 2:
        return <Step2 step={step} />;
    }
  };

  return <div className="w-full h-full">{renderStep()}</div>;
}
